(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("inpl.ads-sidebar", [], factory);
	else if(typeof exports === 'object')
		exports["inpl.ads-sidebar"] = factory();
	else
		root["inpl.ads-sidebar"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition